import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/site/Reveal";

export const Itineraries = () => {
  const { t } = useLang();
  return (
    <section id="itineraries" className="bg-sand py-24 md:py-32" data-testid="itineraries">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="max-w-3xl mb-16">
          <Overline>{t.itineraries.overline}</Overline>
          <h2 className="mt-4 font-serif font-light text-navy text-4xl md:text-6xl tracking-tight">
            {t.itineraries.title}
          </h2>
        </Reveal>

        <div className="border-t border-gold/40">
          {t.itineraries.items.map((it, i) => (
            <Reveal key={it.name} delay={i * 0.06}>
              <div
                data-testid={`itinerary-${i}`}
                className="group grid grid-cols-12 items-baseline gap-4 border-b border-gold/40 py-8 md:py-10 transition-colors hover:bg-canvas/60 px-2"
              >
                <span className="col-span-2 md:col-span-1 font-serif text-2xl md:text-3xl text-gold">{it.n}</span>
                <h3 className="col-span-10 md:col-span-4 font-serif text-3xl md:text-5xl text-navy transition-transform duration-500 group-hover:translate-x-2">
                  {it.name}
                </h3>
                <p className="col-span-12 md:col-span-7 font-light leading-relaxed text-navy/70 md:pl-8">
                  {it.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
